export default __webpack_public_path__ + "static/bbbc-landing-banner-tablet-a02f52622cafe1f17422584f92c71cc9.webp";